<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    max-width="650px"
    transition="dialog-transition">
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip top>
        <template v-slot:activator="{ on:tooltip }">
          <v-btn color="#0B3F67" :disabled="disable" dark v-on="{ ...dialog, ...tooltip }">Replicar Parámetros<v-icon right>mdi-plus-box-outline</v-icon></v-btn>
        </template>
        Replicar Parámetros
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="pa-0">
        <ModalTitle titulo="Replicar Parametros del Año anterior" @cancelar="cancelar"/>
      </v-card-title>
      <v-card-text>
        <div class="pt-4 pb-2 text-subtitle-1">
            ¿Desea replicar la configuraci&oacute;n del <Strong> {{ anterior }} </Strong>
            para el año <strong> {{ actual }} </strong>?
        </div>
        <div class="pt-2">
            <v-alert
                outlined
                prominent
                shaped
                text
                type="warning"
            >
                <div>
                    Advertencia esta acci&oacute;n, modifica los par&aacute;metros del <strong> {{ actual }} </strong>
                </div>
                <div>
                    para replicarlos igual a los configurados en el año <Strong> {{ anterior }} </Strong>.
                </div>
            </v-alert>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="cancelar" text color="error">Cancelar</v-btn>
        <v-btn @click="aceptar" text color="#0B3F67">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from '@/axios'
import ModalTitle from '@/components/utils/ModalTitleComponent'
export default {
    props: [
        'actual',
        'disable',
        'idCategoria'
    ],
    components: {
        ModalTitle
    },
    computed : {
        anterior() {
            return this.actual != null ? (this.actual - 1) : ''
        }
    },
    data: () => ({
        dialog: false,
        backupItem: null
    }),
    methods: {
        aceptar() {
            this.loadingModal(true);
            axios.post(`/categoria/replicarParametros/${this.actual}/${this.idCategoria}`).then(() => {
                this.loadingModal(false);
                this.$emit('reload')
                this.cancelar()
            }).catch(error => {
                if (error.request && error.request.status === 401) {
                    this.$store.commit('showSessionDialog', true);
                } else {
                    console.log(error);
                    this.loadingModal(false);
                }
            })
        },
        cancelar() {
            this.dialog = !this.dialog;
        },
        loadingModal(modal) {                        
            this.$store.dispatch('loadingPage', modal);
        },
    },
}
</script>